import {
  WSElement,
  WSGrid,
  WSPage,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import {
  PayablesStatusFilter,
  PayablesTable,
  usePayablesQuery
} from "../../components/NewPayablesTable/PayablesTable";
import { useDefaultCurrency } from "../../../shared/hooks/useDefaultCurrency";
import { PayableActionBlock } from "../../components/PayableActionBlock/PayableActionBlock";
import { PayablesSummary } from "../../components/PayablesSummary/PayablesSummary";
import { useOpenAll } from "../../utils/payables/openAll";

export const PayablesDrafts: React.FC = () => {
  const history = useHistory();
  useBrowserPageTitle("Draft Payables");
  const defaultCurrency = useDefaultCurrency();

  const queryPayablesDraft = usePayablesQuery({
    status: [PayablesStatusFilter.Draft]
  });

  const listSize = queryPayablesDraft.data?.summary.listSize || 0;
  const totalAmount = queryPayablesDraft.data?.summary.totalValue || 0;

  const { act: openAll, isLoading: openAllIsLoading } = useOpenAll();

  return (
    <WSPage
      title="Draft Payables"
      breadcrumb={{
        label: "Payables to approve",
        icon: "arrow-left",
        onClick: () => history.push("/member/invoices/payables/to-approve")
      }}
    >
      <WSText color="gray600" mb="2XL">
        Draft/unsent payables
      </WSText>

      <WSElement mb="2XL">
        <WSGrid>
          <WSGrid.Item span={{ xs: "2" }}>
            <PayablesSummary
              label="Total amount"
              filter={{
                status: [PayablesStatusFilter.Draft]
              }}
              displayAmount
            />
          </WSGrid.Item>
          <WSGrid.Item span={{ xs: "2" }}>
            <PayablesSummary
              label="Total 1099s"
              filter={{
                status: [PayablesStatusFilter.Draft]
              }}
            />
          </WSGrid.Item>
        </WSGrid>
      </WSElement>

      {listSize > 1 && (
        <PayableActionBlock
          mb="XL"
          rightButton={{
            children: `Move ${listSize} payables to open`,
            onClick: openAll,
            loading: openAllIsLoading
          }}
        >
          <WSText color="gray500" mb="XS">
            <WSText as="b" inline color="gray700">
              Draft payables:
            </WSText>{" "}
            {listSize} payables totaling{" "}
            {formatMoney(totalAmount, defaultCurrency)}.
          </WSText>
        </PayableActionBlock>
      )}

      <PayablesTable
        bulkActions={["open", "delete"]}
        basePath="/member/invoices/payables/draft"
        visibleFilters={{
          payee: true,
          openedAtRange: true
        }}
        defaultFilters={{
          status: [PayablesStatusFilter.Draft]
        }}
        showHeaders
        showDateRequested
        emptyState={{
          standart: "No unsent payables."
        }}
      />
    </WSPage>
  );
};
